//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  computed: {
    useTypeCertificate: function () {
      return Boolean(this.values?.allow_paper === 1 || this.values?.allow_paper === true)
    },
  },

  components: {
    NewCertificate: () => import("~/components/certifikaty-templates/NewSertificat.vue"),
    OldCertificate: () => import("~/components/certifikaty-templates/OldCertificate.vue"),
  }
});
